/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require("google-protobuf");
var goog = jspb;
var global = Function("return this")();

var Request_pb = require("./Request_pb.js");
var Response_pb = require("./Response_pb.js");
goog.exportSymbol("proto.proto.InfoConfig", null, global);
goog.exportSymbol("proto.proto.InfoConfigResponse", null, global);
goog.exportSymbol("proto.proto.InfoConfigResponse.Debugger", null, global);
goog.exportSymbol("proto.proto.InfoConfigResponse.Tab", null, global);
goog.exportSymbol("proto.proto.MicroService", null, global);
goog.exportSymbol("proto.proto.MicroService.ConnectionType", null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.InfoConfig = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.InfoConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.InfoConfig.displayName = "proto.proto.InfoConfig";
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.InfoConfig.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.InfoConfig.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.InfoConfig} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.InfoConfig.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        request: (f = msg.getRequest()) && Request_pb.Request.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.InfoConfig}
 */
proto.proto.InfoConfig.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.InfoConfig();
  return proto.proto.InfoConfig.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.InfoConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.InfoConfig}
 */
proto.proto.InfoConfig.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new Request_pb.Request();
        reader.readMessage(value, Request_pb.Request.deserializeBinaryFromReader);
        msg.setRequest(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.InfoConfig.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.InfoConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.InfoConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.InfoConfig.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(1, f, Request_pb.Request.serializeBinaryToWriter);
  }
};

/**
 * optional Request request = 1;
 * @return {?proto.proto.Request}
 */
proto.proto.InfoConfig.prototype.getRequest = function () {
  return /** @type{?proto.proto.Request} */ (jspb.Message.getWrapperField(this, Request_pb.Request, 1));
};

/** @param {?proto.proto.Request|undefined} value */
proto.proto.InfoConfig.prototype.setRequest = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.proto.InfoConfig.prototype.clearRequest = function () {
  this.setRequest(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.InfoConfig.prototype.hasRequest = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.InfoConfigResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.InfoConfigResponse.repeatedFields_, null);
};
goog.inherits(proto.proto.InfoConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.InfoConfigResponse.displayName = "proto.proto.InfoConfigResponse";
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.InfoConfigResponse.repeatedFields_ = [10];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.InfoConfigResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.InfoConfigResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.InfoConfigResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.InfoConfigResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        response: (f = msg.getResponse()) && Response_pb.Response.toObject(includeInstance, f),
        debugMode: jspb.Message.getFieldWithDefault(msg, 2, false),
        defaultTimeout: jspb.Message.getFieldWithDefault(msg, 3, 0),
        optimizeMode: jspb.Message.getFieldWithDefault(msg, 4, false),
        maxFileSize: jspb.Message.getFieldWithDefault(msg, 5, "0"),
        captionLengthMax: jspb.Message.getFieldWithDefault(msg, 6, "0"),
        messageLengthMax: jspb.Message.getFieldWithDefault(msg, 7, "0"),
        groupAddMemberLimit: jspb.Message.getFieldWithDefault(msg, 8, 0),
        channelAddMemberLimit: jspb.Message.getFieldWithDefault(msg, 9, 0),
        microServiceList: jspb.Message.toObjectList(msg.getMicroServiceList(), proto.proto.MicroService.toObject, includeInstance),
        pb_debugger: jspb.Message.getFieldWithDefault(msg, 11, 0),
        baseUrl: jspb.Message.getFieldWithDefault(msg, 12, ""),
        showAdvertising: jspb.Message.getFieldWithDefault(msg, 13, false),
        defaulttab: jspb.Message.getFieldWithDefault(msg, 14, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.InfoConfigResponse}
 */
proto.proto.InfoConfigResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.InfoConfigResponse();
  return proto.proto.InfoConfigResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.InfoConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.InfoConfigResponse}
 */
proto.proto.InfoConfigResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new Response_pb.Response();
        reader.readMessage(value, Response_pb.Response.deserializeBinaryFromReader);
        msg.setResponse(value);
        break;
      case 2:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setDebugMode(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setDefaultTimeout(value);
        break;
      case 4:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setOptimizeMode(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readUint64String());
        msg.setMaxFileSize(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readUint64String());
        msg.setCaptionLengthMax(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readUint64String());
        msg.setMessageLengthMax(value);
        break;
      case 8:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setGroupAddMemberLimit(value);
        break;
      case 9:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setChannelAddMemberLimit(value);
        break;
      case 10:
        var value = new proto.proto.MicroService();
        reader.readMessage(value, proto.proto.MicroService.deserializeBinaryFromReader);
        msg.addMicroService(value);
        break;
      case 11:
        var value = /** @type {!proto.proto.InfoConfigResponse.Debugger} */ (reader.readEnum());
        msg.setDebugger(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setBaseUrl(value);
        break;
      case 13:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setShowAdvertising(value);
        break;
      case 14:
        var value = /** @type {!proto.proto.InfoConfigResponse.Tab} */ (reader.readEnum());
        msg.setDefaulttab(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.InfoConfigResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.InfoConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.InfoConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.InfoConfigResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(1, f, Response_pb.Response.serializeBinaryToWriter);
  }
  f = message.getDebugMode();
  if (f) {
    writer.writeBool(2, f);
  }
  f = message.getDefaultTimeout();
  if (f !== 0) {
    writer.writeUint32(3, f);
  }
  f = message.getOptimizeMode();
  if (f) {
    writer.writeBool(4, f);
  }
  f = message.getMaxFileSize();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(5, f);
  }
  f = message.getCaptionLengthMax();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(6, f);
  }
  f = message.getMessageLengthMax();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(7, f);
  }
  f = message.getGroupAddMemberLimit();
  if (f !== 0) {
    writer.writeUint32(8, f);
  }
  f = message.getChannelAddMemberLimit();
  if (f !== 0) {
    writer.writeUint32(9, f);
  }
  f = message.getMicroServiceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(10, f, proto.proto.MicroService.serializeBinaryToWriter);
  }
  f = message.getDebugger();
  if (f !== 0.0) {
    writer.writeEnum(11, f);
  }
  f = message.getBaseUrl();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getShowAdvertising();
  if (f) {
    writer.writeBool(13, f);
  }
  f = message.getDefaulttab();
  if (f !== 0.0) {
    writer.writeEnum(14, f);
  }
};

/**
 * @enum {number}
 */
proto.proto.InfoConfigResponse.Debugger = {
  CRASHLYTICS: 0,
  SENTRY: 1,
};

/**
 * @enum {number}
 */
proto.proto.InfoConfigResponse.Tab = {
  CONTACT: 0,
  CALL: 1,
  CHAT: 2,
  ILAND: 3,
  SETTING: 4,
};

/**
 * optional Response response = 1;
 * @return {?proto.proto.Response}
 */
proto.proto.InfoConfigResponse.prototype.getResponse = function () {
  return /** @type{?proto.proto.Response} */ (jspb.Message.getWrapperField(this, Response_pb.Response, 1));
};

/** @param {?proto.proto.Response|undefined} value */
proto.proto.InfoConfigResponse.prototype.setResponse = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.proto.InfoConfigResponse.prototype.clearResponse = function () {
  this.setResponse(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.InfoConfigResponse.prototype.hasResponse = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional bool debug_mode = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.InfoConfigResponse.prototype.getDebugMode = function () {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};

/** @param {boolean} value */
proto.proto.InfoConfigResponse.prototype.setDebugMode = function (value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};

/**
 * optional uint32 default_timeout = 3;
 * @return {number}
 */
proto.proto.InfoConfigResponse.prototype.getDefaultTimeout = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.proto.InfoConfigResponse.prototype.setDefaultTimeout = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional bool optimize_mode = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.InfoConfigResponse.prototype.getOptimizeMode = function () {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};

/** @param {boolean} value */
proto.proto.InfoConfigResponse.prototype.setOptimizeMode = function (value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};

/**
 * optional uint64 max_file_size = 5;
 * @return {string}
 */
proto.proto.InfoConfigResponse.prototype.getMaxFileSize = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};

/** @param {string} value */
proto.proto.InfoConfigResponse.prototype.setMaxFileSize = function (value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};

/**
 * optional uint64 caption_length_max = 6;
 * @return {string}
 */
proto.proto.InfoConfigResponse.prototype.getCaptionLengthMax = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};

/** @param {string} value */
proto.proto.InfoConfigResponse.prototype.setCaptionLengthMax = function (value) {
  jspb.Message.setProto3StringIntField(this, 6, value);
};

/**
 * optional uint64 message_length_max = 7;
 * @return {string}
 */
proto.proto.InfoConfigResponse.prototype.getMessageLengthMax = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, "0"));
};

/** @param {string} value */
proto.proto.InfoConfigResponse.prototype.setMessageLengthMax = function (value) {
  jspb.Message.setProto3StringIntField(this, 7, value);
};

/**
 * optional uint32 group_add_member_limit = 8;
 * @return {number}
 */
proto.proto.InfoConfigResponse.prototype.getGroupAddMemberLimit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};

/** @param {number} value */
proto.proto.InfoConfigResponse.prototype.setGroupAddMemberLimit = function (value) {
  jspb.Message.setProto3IntField(this, 8, value);
};

/**
 * optional uint32 channel_add_member_limit = 9;
 * @return {number}
 */
proto.proto.InfoConfigResponse.prototype.getChannelAddMemberLimit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};

/** @param {number} value */
proto.proto.InfoConfigResponse.prototype.setChannelAddMemberLimit = function (value) {
  jspb.Message.setProto3IntField(this, 9, value);
};

/**
 * repeated MicroService micro_service = 10;
 * @return {!Array<!proto.proto.MicroService>}
 */
proto.proto.InfoConfigResponse.prototype.getMicroServiceList = function () {
  return /** @type{!Array<!proto.proto.MicroService>} */ (jspb.Message.getRepeatedWrapperField(this, proto.proto.MicroService, 10));
};

/** @param {!Array<!proto.proto.MicroService>} value */
proto.proto.InfoConfigResponse.prototype.setMicroServiceList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 10, value);
};

/**
 * @param {!proto.proto.MicroService=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.MicroService}
 */
proto.proto.InfoConfigResponse.prototype.addMicroService = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.proto.MicroService, opt_index);
};

proto.proto.InfoConfigResponse.prototype.clearMicroServiceList = function () {
  this.setMicroServiceList([]);
};

/**
 * optional Debugger debugger = 11;
 * @return {!proto.proto.InfoConfigResponse.Debugger}
 */
proto.proto.InfoConfigResponse.prototype.getDebugger = function () {
  return /** @type {!proto.proto.InfoConfigResponse.Debugger} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};

/** @param {!proto.proto.InfoConfigResponse.Debugger} value */
proto.proto.InfoConfigResponse.prototype.setDebugger = function (value) {
  jspb.Message.setProto3EnumField(this, 11, value);
};

/**
 * optional string base_url = 12;
 * @return {string}
 */
proto.proto.InfoConfigResponse.prototype.getBaseUrl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};

/** @param {string} value */
proto.proto.InfoConfigResponse.prototype.setBaseUrl = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional bool show_advertising = 13;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.InfoConfigResponse.prototype.getShowAdvertising = function () {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 13, false));
};

/** @param {boolean} value */
proto.proto.InfoConfigResponse.prototype.setShowAdvertising = function (value) {
  jspb.Message.setProto3BooleanField(this, 13, value);
};

/**
 * optional Tab defaultTab = 14;
 * @return {!proto.proto.InfoConfigResponse.Tab}
 */
proto.proto.InfoConfigResponse.prototype.getDefaulttab = function () {
  return /** @type {!proto.proto.InfoConfigResponse.Tab} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};

/** @param {!proto.proto.InfoConfigResponse.Tab} value */
proto.proto.InfoConfigResponse.prototype.setDefaulttab = function (value) {
  jspb.Message.setProto3EnumField(this, 14, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.MicroService = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.MicroService, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.MicroService.displayName = "proto.proto.MicroService";
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.MicroService.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.MicroService.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.MicroService} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.MicroService.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        name: jspb.Message.getFieldWithDefault(msg, 1, ""),
        type: jspb.Message.getFieldWithDefault(msg, 2, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.MicroService}
 */
proto.proto.MicroService.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.MicroService();
  return proto.proto.MicroService.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.MicroService} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.MicroService}
 */
proto.proto.MicroService.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 2:
        var value = /** @type {!proto.proto.MicroService.ConnectionType} */ (reader.readEnum());
        msg.setType(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.MicroService.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.MicroService.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.MicroService} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MicroService.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
};

/**
 * @enum {number}
 */
proto.proto.MicroService.ConnectionType = {
  HTTPS: 0,
  SOCKET: 1,
};

/**
 * optional string name = 1;
 * @return {string}
 */
proto.proto.MicroService.prototype.getName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};

/** @param {string} value */
proto.proto.MicroService.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional ConnectionType type = 2;
 * @return {!proto.proto.MicroService.ConnectionType}
 */
proto.proto.MicroService.prototype.getType = function () {
  return /** @type {!proto.proto.MicroService.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {!proto.proto.MicroService.ConnectionType} value */
proto.proto.MicroService.prototype.setType = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};

goog.object.extend(exports, proto.proto);
